import { useEffect, useState } from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { http, API } from "@/lib/api";
import { INSTAGRAM_URL, INSTAGRAM_HANDLE, InstagramIcon } from "@/components/Social";

const FEATURED_POSTS = [
  { id: "sheerine-jonathan", image: "https://customer-assets-jai6qajn.emergentagent.net/job_custom-canvas-25/artifacts/6f729a71926a9d3f_b8797062-ede8-4b91-90ed-95407669a9fc.jpeg", alt: "Panneau Sheerine & Jonathan sur chevalet, accompagné de fleurs blanches" },
  { id: "camilia-semy", image: "https://customer-assets-jai6qajn.emergentagent.net/job_custom-canvas-25/artifacts/312cc4ae5a9b1290_c0d72032-420c-4271-a131-26152980ab3f.jpeg", alt: "Panneau Camilia & Semy pour une gender reveal, avec fleurs roses et bleues" },
  { id: "marwa-salah", image: "https://customer-assets-jai6qajn.emergentagent.net/job_custom-canvas-25/artifacts/a85cac772975fcba_d81b6123-0dcc-450e-8c5b-4bb346e09131.jpeg", alt: "Panneau Marwa & Salah et leurs photos d’enfance sur un chevalet blanc" },
];

const Tile = ({ href, children, testId, label }) => (
  <a href={href} target="_blank" rel="noreferrer" data-testid={testId} aria-label={label}
    className="group relative block aspect-[4/5] rounded-2xl overflow-hidden border border-[#C2B4A2]/70 grad-card focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#7B5338]">
    {children}
    <span className="absolute inset-0 bg-[#3A322B]/0 group-hover:bg-[#3A322B]/35 transition-colors duration-300 flex items-center justify-center">
      <InstagramIcon size={34} className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
    </span>
  </a>
);

export const InstagramSection = () => {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    http.get("/instagram").then((r) => setPosts(r.data)).catch(() => setPosts([]));
  }, []);

  const visiblePosts = posts.length ? posts : FEATURED_POSTS;

  return (
    <section className="grad-ivory border-t border-[#DDD3C6]" data-testid="instagram-section">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-10 py-24">
        <div className="text-center mb-12">
          <span className="label-xs">Instagram</span>
          <h2 className="font-display text-4xl lg:text-5xl mt-3 uppercase tracking-[0.1em] text-gradient">Suivez-nous</h2>
          <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 mt-4 text-[#7B5338] hover:underline underline-offset-4" data-testid="instagram-profile-link">
            <InstagramIcon size={18} /> {INSTAGRAM_HANDLE}
          </a>
        </div>
        <Carousel opts={{ align: "start", loop: visiblePosts.length > 3 }} data-testid="instagram-carousel">
          <CarouselContent className="-ml-4 lg:-ml-6">
            {visiblePosts.map((p) => (
              <CarouselItem key={p.id} className="pl-4 lg:pl-6 basis-[85%] sm:basis-1/2 md:basis-1/3">
                <Tile href={p.link || INSTAGRAM_URL} testId={`instagram-post-${p.id}`} label={`${p.alt || "Création MS SIGNATURE"} — voir sur Instagram`}>
                  <img src={p.image || `${API}/instagram/${p.id}/photo`} alt={p.alt || "Publication Instagram MS SIGNATURE"} loading="lazy" decoding="async" className="w-full h-full object-cover" data-testid={`instagram-photo-${p.id}`} />
                </Tile>
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className={`flex justify-end gap-3 mt-6 ${visiblePosts.length <= 3 ? "md:hidden" : ""}`}>
            <CarouselPrevious className="static translate-y-0 h-11 w-11 bg-white border-[#C2B4A2]" aria-label="Photo précédente" data-testid="instagram-prev-button" />
            <CarouselNext className="static translate-y-0 h-11 w-11 bg-white border-[#C2B4A2]" aria-label="Photo suivante" data-testid="instagram-next-button" />
          </div>
        </Carousel>
      </div>
    </section>
  );
};
